/* eslint-disable sort-keys, sort-keys-fix/sort-keys-fix */

export const TAG_KEYS_MAP = {
  // HTML attributes
  accept: 'accept',

  acceptcharset: 'acceptCharset',

  accesskey: 'accessKey',

  action: 'action',

  allowfullscreen: 'allowFullScreen',

  allowtransparency: 'allowTransparency',

  alt: 'alt',

  async: 'async',

  autocomplete: 'autoComplete',

  autofocus: 'autoFocus',

  autoplay: 'autoPlay',

  capture: 'capture',

  cellpadding: 'cellPadding',

  cellspacing: 'cellSpacing',

  challenge: 'challenge',

  charset: 'charSet',

  checked: 'checked',

  cite: 'cite',

  class: 'className',

  classid: 'classID',

  classname: 'className',

  cols: 'cols',

  colspan: 'colSpan',

  content: 'content',

  contenteditable: 'contentEditable',

  contextmenu: 'contextMenu',

  controls: 'controls',

  coords: 'coords',

  crossorigin: 'crossOrigin',

  data: 'data',

  datetime: 'dateTime',

  default: 'default',

  defer: 'defer',

  dir: 'dir',

  disabled: 'disabled',

  // SVG attributes
  accentheight: 'accentHeight',

  download: 'download',

  accumulate: 'accumulate',

  draggable: 'draggable',

  additive: 'additive',

  enctype: 'encType',

  alignmentbaseline: 'alignmentBaseline',

  // Specials
  for: 'htmlFor',

  allowreorder: 'allowReorder',

  form: 'form',

  alphabetic: 'alphabetic',

  formaction: 'formAction',

  amplitude: 'amplitude',

  formenctype: 'formEncType',

  arabicform: 'arabicForm',

  formmethod: 'formMethod',

  ascent: 'ascent',

  formnovalidate: 'formNoValidate',

  attributename: 'attributeName',

  formtarget: 'formTarget',

  attributetype: 'attributeType',

  frameborder: 'frameBorder',

  autoreverse: 'autoReverse',

  headers: 'headers',

  azimuth: 'azimuth',

  height: 'height',

  basefrequency: 'baseFrequency',

  hidden: 'hidden',

  baselineshift: 'baselineShift',

  high: 'high',

  baseprofile: 'baseProfile',

  href: 'href',

  bbox: 'bbox',

  hreflang: 'hrefLang',

  begin: 'begin',

  htmlfor: 'htmlFor',

  bias: 'bias',

  httpequiv: 'httpEquiv',

  by: 'by',

  icon: 'icon',

  calcmode: 'calcMode',

  id: 'id',

  capheight: 'capHeight',

  inputmode: 'inputMode',

  clip: 'clip',

  integrity: 'integrity',

  clippath: 'clipPath',

  is: 'is',

  clippathunits: 'clipPathUnits',

  keyparams: 'keyParams',

  cliprule: 'clipRule',

  keytype: 'keyType',

  colorinterpolation: 'colorInterpolation',

  kind: 'kind',

  colorinterpolationfilters: 'colorInterpolationFilters',

  label: 'label',

  colorprofile: 'colorProfile',

  lang: 'lang',

  colorrendering: 'colorRendering',

  list: 'list',

  contentscripttype: 'contentScriptType',

  loop: 'loop',

  contentstyletype: 'contentStyleType',

  low: 'low',

  cursor: 'cursor',

  manifest: 'manifest',

  cx: 'cx',

  marginheight: 'marginHeight',

  cy: 'cy',

  marginwidth: 'marginWidth',

  d: 'd',

  max: 'max',

  decelerate: 'decelerate',

  maxlength: 'maxLength',

  descent: 'descent',

  media: 'media',

  diffuseconstant: 'diffuseConstant',

  mediagroup: 'mediaGroup',

  direction: 'direction',

  method: 'method',

  display: 'display',

  min: 'min',

  divisor: 'divisor',

  minlength: 'minLength',

  dominantbaseline: 'dominantBaseline',

  multiple: 'multiple',

  dur: 'dur',

  muted: 'muted',

  dx: 'dx',

  name: 'name',

  dy: 'dy',
  nonce: 'nonce',
  edgemode: 'edgeMode',
  novalidate: 'noValidate',
  elevation: 'elevation',
  open: 'open',
  enablebackground: 'enableBackground',
  optimum: 'optimum',
  end: 'end',
  pattern: 'pattern',
  exponent: 'exponent',
  placeholder: 'placeholder',
  externalresourcesrequired: 'externalResourcesRequired',
  poster: 'poster',
  fill: 'fill',
  preload: 'preload',
  fillopacity: 'fillOpacity',
  profile: 'profile',
  fillrule: 'fillRule',
  radiogroup: 'radioGroup',
  filter: 'filter',
  readonly: 'readOnly',
  filterres: 'filterRes',
  rel: 'rel',
  filterunits: 'filterUnits',
  required: 'required',
  floodcolor: 'floodColor',
  reversed: 'reversed',
  floodopacity: 'floodOpacity',
  role: 'role',
  focusable: 'focusable',
  rows: 'rows',
  fontfamily: 'fontFamily',
  rowspan: 'rowSpan',
  fontsize: 'fontSize',
  sandbox: 'sandbox',
  fontsizeadjust: 'fontSizeAdjust',
  scope: 'scope',
  fontstretch: 'fontStretch',
  scoped: 'scoped',
  fontstyle: 'fontStyle',
  scrolling: 'scrolling',
  fontvariant: 'fontVariant',
  seamless: 'seamless',
  fontweight: 'fontWeight',
  selected: 'selected',
  format: 'format',
  shape: 'shape',
  from: 'from',
  size: 'size',
  fx: 'fx',
  sizes: 'sizes',
  fy: 'fy',
  span: 'span',
  g1: 'g1',
  spellcheck: 'spellCheck',
  g2: 'g2',
  src: 'src',
  glyphname: 'glyphName',
  srcdoc: 'srcDoc',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  srclang: 'srcLang',
  glyphorientationvertical: 'glyphOrientationVertical',
  srcset: 'srcSet',
  glyphref: 'glyphRef',
  start: 'start',
  gradienttransform: 'gradientTransform',
  step: 'step',
  gradientunits: 'gradientUnits',
  style: 'style',
  hanging: 'hanging',
  summary: 'summary',
  horizadvx: 'horizAdvX',
  tabindex: 'tabIndex',
  horizoriginx: 'horizOriginX',
  target: 'target',
  ideographic: 'ideographic',
  title: 'title',
  imagerendering: 'imageRendering',
  type: 'type',
  in: 'in',
  usemap: 'useMap',
  in2: 'in2',
  value: 'value',
  intercept: 'intercept',
  width: 'width',
  k: 'k',
  wmode: 'wmode',
  k1: 'k1',
  wrap: 'wrap',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  lightingcolor: 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  markerstart: 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  overlinethickness: 'overlineThickness',
  paintorder: 'paintOrder',
  panose1: 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  // Events
  onabort: 'onAbort',

  restart: 'restart',

  onanimationend: 'onAnimationEnd',

  result: 'result',

  onanimationiteration: 'onAnimationIteration',

  rotate: 'rotate',

  onanimationstart: 'onAnimationStart',

  rx: 'rx',

  onblur: 'onBlur',

  ry: 'ry',

  oncanplay: 'onCanPlay',

  scale: 'scale',

  oncanplaythrough: 'onCanPlayThrough',

  seed: 'seed',

  onchange: 'onChange',

  shaperendering: 'shapeRendering',

  onclick: 'onClick',

  slope: 'slope',

  oncompositionend: 'onCompositionEnd',

  spacing: 'spacing',

  oncompositionstart: 'onCompositionStart',

  specularconstant: 'specularConstant',

  oncompositionupdate: 'onCompositionUpdate',

  specularexponent: 'specularExponent',

  oncontextmenu: 'onContextMenu',

  speed: 'speed',

  oncopy: 'onCopy',

  spreadmethod: 'spreadMethod',

  oncut: 'onCut',

  startoffset: 'startOffset',

  ondoubleclick: 'onDoubleClick',

  stddeviation: 'stdDeviation',

  ondrag: 'onDrag',

  stemh: 'stemh',

  ondragend: 'onDragEnd',

  stemv: 'stemv',

  ondragenter: 'onDragEnter',

  stitchtiles: 'stitchTiles',

  ondragexit: 'onDragExit',

  stopcolor: 'stopColor',

  ondragleave: 'onDragLeave',

  stopopacity: 'stopOpacity',

  ondragover: 'onDragOver',

  strikethroughposition: 'strikethroughPosition',

  ondragstart: 'onDragStart',

  strikethroughthickness: 'strikethroughThickness',

  ondrop: 'onDrop',

  string: 'string',

  ondurationchange: 'onDurationChange',

  stroke: 'stroke',

  onemptied: 'onEmptied',

  strokedasharray: 'strokeDasharray',

  onencrypted: 'onEncrypted',

  strokedashoffset: 'strokeDashoffset',

  onended: 'onEnded',

  strokelinecap: 'strokeLinecap',

  onerror: 'onError',

  strokelinejoin: 'strokeLinejoin',

  onfocus: 'onFocus',

  strokemiterlimit: 'strokeMiterlimit',

  oninput: 'onInput',

  strokeopacity: 'strokeOpacity',

  onkeydown: 'onKeyDown',

  strokewidth: 'strokeWidth',

  onkeypress: 'onKeyPress',

  surfacescale: 'surfaceScale',

  onkeyup: 'onKeyUp',

  systemlanguage: 'systemLanguage',

  onload: 'onLoad',

  tablevalues: 'tableValues',

  onloadeddata: 'onLoadedData',

  targetx: 'targetX',

  onloadedmetadata: 'onLoadedMetadata',

  targety: 'targetY',

  onloadstart: 'onLoadStart',

  textanchor: 'textAnchor',

  onmousedown: 'onMouseDown',

  textdecoration: 'textDecoration',

  onmouseenter: 'onMouseEnter',

  textlength: 'textLength',

  onmouseleave: 'onMouseLeave',

  textrendering: 'textRendering',

  onmousemove: 'onMouseMove',

  to: 'to',

  onmouseout: 'onMouseOut',

  transform: 'transform',

  onmouseover: 'onMouseOver',

  u1: 'u1',

  onmouseup: 'onMouseUp',

  u2: 'u2',

  onpaste: 'onPaste',
  underlineposition: 'underlinePosition',
  onpause: 'onPause',
  underlinethickness: 'underlineThickness',
  onplay: 'onPlay',
  unicode: 'unicode',
  onplaying: 'onPlaying',
  unicodebidi: 'unicodeBidi',
  onprogress: 'onProgress',
  unicoderange: 'unicodeRange',
  onratechange: 'onRateChange',
  unitsperem: 'unitsPerEm',
  onscroll: 'onScroll',
  valphabetic: 'vAlphabetic',
  onseeked: 'onSeeked',
  values: 'values',
  onseeking: 'onSeeking',
  vectoreffect: 'vectorEffect',
  onselect: 'onSelect',
  version: 'version',
  onstalled: 'onStalled',
  vertadvy: 'vertAdvY',
  onsubmit: 'onSubmit',
  vertoriginx: 'vertOriginX',
  onsuspend: 'onSuspend',
  vertoriginy: 'vertOriginY',
  ontimeupdate: 'onTimeUpdate',
  vhanging: 'vHanging',
  ontouchcancel: 'onTouchCancel',
  videographic: 'vIdeographic',
  ontouchend: 'onTouchEnd',
  viewbox: 'viewBox',
  ontouchmove: 'onTouchMove',
  viewtarget: 'viewTarget',
  ontouchstart: 'onTouchStart',
  visibility: 'visibility',
  ontransitionend: 'onTransitionEnd',
  vmathematical: 'vMathematical',
  onvolumechange: 'onVolumeChange',
  widths: 'widths',
  onwaiting: 'onWaiting',
  wordspacing: 'wordSpacing',
  onwheel: 'onWheel',
  writingmode: 'writingMode',
  x: 'x',
  x1: 'x1',
  x2: 'x2',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  xlinkactuate: 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  xlinkrole: 'xlinkRole',
  xlinkshow: 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  xlinktype: 'xlinkType',
  xmlbase: 'xmlBase',
  xmllang: 'xmlLang',
  xmlns: 'xmlns',
  xmlnsxlink: 'xmlnsXlink',
  xmlspace: 'xmlSpace',
  y: 'y',
  y1: 'y1',
  y2: 'y2',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan',
};
